var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSettingMenuInGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 72 72",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.4 23.643a2.373 2.373 0 0 1 2.374-2.373h37.963a2.373 2.373 0 0 1 0 4.746H16.774a2.373 2.373 0 0 1-2.373-2.373m0 12.654a2.373 2.373 0 0 1 2.374-2.372h37.963a2.373 2.373 0 0 1 0 4.745H16.774a2.373 2.373 0 0 1-2.373-2.373m0 12.655a2.373 2.373 0 0 1 2.374-2.373h37.963a2.373 2.373 0 0 1 0 4.746H16.774a2.373 2.373 0 0 1-2.373-2.373",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    strokeWidth: 6,
    d: "M16.774 18.27a5.373 5.373 0 1 0 0 10.746h37.963a5.373 5.373 0 0 0 0-10.746zm0 12.655a5.373 5.373 0 0 0 0 10.745h37.963a5.373 5.373 0 0 0 0-10.745zm0 12.654a5.373 5.373 0 0 0 0 10.746h37.963a5.373 5.373 0 1 0 0-10.746z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSettingMenuInGame);
export default __webpack_public_path__ + "static/media/IcoSettingMenuInGame.228ee96458c4edbc4c7c6f70a52b9141.svg";
export { ForwardRef as ReactComponent };